import { Button } from '@blueprintjs/core';
import React from 'react';
import { useMeasure } from 'react-use';
import { intl } from '../../../../core/utils/Intl';
import { IndeterminateButtonContent } from '../../styles/styles';

interface IProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  margin?: string;
  tipLabel?: string;
  disabled?: boolean;
  width?: string;
  excludeBoth?: boolean;
  booleanLabels?: { [key: string]: string };
}

const IndeterminateActionButton = (props: IProps) => {
  const { tipLabel } = props;
  const [refInputComponent, { width: widthComponent }] = useMeasure();
  const getIcon = (value: boolean | null) => {
    switch (value) {
      case true:
        return 'tick-circle';
      case false:
        return 'circle';
      case null:
        return 'ban-circle';
    }
  };

  const getNewValue = (value: boolean | null) => {
    switch (value) {
      case true:
        return false;
      case false:
        return props.excludeBoth ? true : null;
      case null:
        return true;
    }
  };

  const onChange = () => {
    const value = getNewValue(props.value);
    props.onChange(value);
  };

  const createLabelOfState = (value: any) => {
    switch (value) {
      case true:
        return props.booleanLabels ? props.booleanLabels['true'] : intl('app.indeterminateButton.active');
      case false:
        return props.booleanLabels ? props.booleanLabels['false'] : intl('app.indeterminateButton.inactive');
      case null:
        return props.booleanLabels && props.booleanLabels['null']
          ? props.booleanLabels['null']
          : intl('app.indeterminateButton.both');
    }
  };

  return (
    <div ref={refInputComponent}>
      <IndeterminateButtonContent width={props.width} refWidth={widthComponent}>
        {tipLabel && <span className={'tipLabel'}>{tipLabel}</span>}
        <Button
          style={{ margin: props.margin && props.margin }}
          alignText={'right'}
          text={createLabelOfState(props.value)}
          icon={getIcon(props.value)}
          minimal
          onClick={onChange}
          className={'button'}
          disabled={props.disabled}
        />
      </IndeterminateButtonContent>
    </div>
  );
};

export default IndeterminateActionButton;
